module.exports = __webpack_public_path__ + "img/image4.210c6d59.png";